import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./answerMatch.css";
import { connect } from "react-redux";
import Navbar from "../../components/navbar";
import QuestionView from "../questionMatch/questionView";
import Loading from "carbon-components-react/lib/components/Loading";
import { trackPageView, trackEvent } from "../../services/analyticsService";
import AnswerMatchView from "./answerMatchView";
import {
  getVisioAnswer,
  getVisioQualityTags,
  saveVisioAnswer,
  getVisioActivitySummary,
} from "../../services/apiService";
import Timer from "../../components/timer";
import { toastTheError } from "../../services/toastService";

export function AnswerMatch(props) {
  const [inProgress, setInProgress] = useState(false);
  const [answer, setAnswer] = useState(null);
  const [tags, setTags] = useState([]);
  const [noAnswer, setNoAnswer] = useState(false);
  const [unavailable, setUnavailable] = useState(false);
  const [disableUI, setDisableUI] = useState(false);
  const [stats, setStats] = useState({});
  const { t } = useTranslation("kunduz");

  useEffect(() => {
    refreshQualityTags();
    if (props.teacher && props.teacher.is_available) {
      retrieveAnswer();
      refreshStats();
    }
    trackPageView("/answerMatch");
    /*document.addEventListener("keydown", hotKeyListener);
    return () => {
      document.removeEventListener("keydown", hotKeyListener);
    };*/
  }, []);

  useEffect(() => {
    if (props.teacher && props.teacher.is_available) {
      setUnavailable(false);
      retrieveAnswer();
    } else {
      setUnavailable(true);
      setAnswer(null);
    }
  }, [props.teacher]);

  function refreshQualityTags() {
    getVisioQualityTags()
      .then((theTags) => {
        setTags(theTags);
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  function refreshStats() {
    getVisioActivitySummary()
      .then((data) => {
        setStats(data.results[0]);
      })
      .catch((error) => {
        console.warn(error);
      });
  }

  function playDing() {
    try {
      const { teacher } = props;
      if (!teacher) return;
      if (teacher?.phone_number?.country_code != 1) {
        let audio = new Audio(
          "https://ia800203.us.archive.org/14/items/slack_sfx/b2.mp3"
        );
        audio.play();
      }
    } catch (error) {}
  }

  function retrieveAnswer(shouldDing = false) {
    setInProgress(true);
    setAnswer(null);
    setUnavailable(false);
    refreshQualityTags();

    getVisioAnswer()
      .then((answer) => {
        if (answer != "") {
          setAnswer(answer);
          setInProgress(false);
          setNoAnswer(false);
          setDisableUI(false);
          shouldDing && playDing();
        } else {
          setInProgress(false);
          setNoAnswer(true);
          setDisableUI(false);
        }
      })
      .catch((error) => {
        setInProgress(false);
        setNoAnswer(true);
        setDisableUI(false);
        toastTheError(error);
      });
  }

  function renderLoading() {
    return (
      <div className="loading-wrapper">
        <Loading withOverlay={false} />
        <div>{t("retrievingQuestion")}</div>
      </div>
    );
  }

  function renderNoContent() {
    return (
      <div
        className="flex-aic"
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 100,
          paddingBottom: 100,
        }}
      >
        <div>{t("noAnswerFound")}</div>
        <Timer
          expireCallback={() => {
            retrieveAnswer(true);
          }}
        />
      </div>
    );
  }

  function renderMiniStats() {
    if (stats && stats.data) {
      return (
        <div
          style={{
            padding: "10px 16px",
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div>İncelenen Veri: {stats.data.answer_review.count}</div>
          <div>Kazanç: {stats.data.answer_review.earning}</div>
        </div>
      );
    } else {
      return <></>;
    }
  }

  function renderAnswer() {
    return (
      <>
        {renderMiniStats()}
        <div className="question-wrapper">
          <div>
            {answer ? new Date(answer.created_at).toLocaleString() : null}
          </div>
          <QuestionView
            question={answer && answer.question}
            side="left"
            preview={true}
          />
        </div>
        <div className="match-wrapper">
          <AnswerMatchView
            inProgress={disableUI}
            answer={answer && answer.answer}
            tags={tags}
            saveCallback={(tags) => {
              saveCallback(tags);
            }}
            side="right"
          />
        </div>
      </>
    );
  }

  function renderUnavailable() {
    return (
      <div
        className="flex-aic"
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          justifyContent: "center",
          paddingTop: 100,
          paddingBottom: 100,
        }}
      >
        <div>{t("activateMatchStatus")}</div>
      </div>
    );
  }

  function saveCallback(tags) {
    // filter out -1 value
    if (tags && tags.length > 0) {
      tags = tags.filter((tag) => {
        return tag != -1;
      });
    }
    setDisableUI(true);
    saveVisioAnswer(answer.id, tags)
      .then(() => {
        retrieveAnswer();
      })
      .catch((error) => {
        retrieveAnswer();
        toastTheError(error);
      })
      .finally(() => {
        setDisableUI(false);
        refreshStats();
      });
  }

  if (!props.teacher) {
    return <Redirect to="/login" />;
  }

  return (
    <div className="view">
      <Navbar />
      <div className="answer-match-view">
        <div className="content-wrapper">
          {unavailable
            ? renderUnavailable()
            : inProgress
            ? renderLoading()
            : noAnswer
            ? renderNoContent()
            : renderAnswer()}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    teacher: state.teacher,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AnswerMatch);
